import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ProductosDTO } from 'src/app/model/productosDTO';
import { ProductoDTOService } from 'src/app/services/api/productoDTO.service';
import { TokenStorageServiceCliente } from 'src/app/services/api/TokenStorageServiceCliente';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-privacity',
  templateUrl: './privacity.component.html',
  styleUrl: './privacity.component.css'
})
export class PrivacityComponent implements OnInit {
  nombreCuenta:String="Mi cuenta";
  countpedido:number=0;
  tieneSession:boolean=false ;
  modoBusqueda:boolean=false;
  productosdto:ProductosDTO[]=[];
  formBuscar!: FormGroup;
  content:any = [];
  currentPage:number=0;
  totalPages:number=0;
  page = 0;
  size = 6;
  order = 'descripcion';
  asc = true;
  tipoMedia2$ : String = "/0";
  ocultarCarrito:boolean=false;
  urlServerUploadArticulos$ : string = `${environment.HOST}/api/media/`;
  constructor(
    private router:Router,
    private tokenStorage: TokenStorageServiceCliente,
    private productoDTOService:ProductoDTOService,
  ){

  }


  ngOnInit(): void {
    this.formBuscar = new FormGroup({
      'txtBuscar' : new FormControl('', Validators.required),
      'btnBuscarAll' : new FormControl('', Validators.required),
    });

  }

  logout(){
    this.tokenStorage.signOut();
    localStorage.removeItem('shopping');

    this.router.navigate(['/inicio'])
    .then(() => {
      window.location.reload();
    });

  }

  OnBuscarAll(){

    this.modoBusqueda=true;
    this.currentPage=0;
    this.content=[];

this.CargarPorDescripcionPg();


    }

    OnHabilitarBusqueda(){
      this.ocultarCarrito=true;
    }
    
    OnCerrarBusqueda(){
      this.ocultarCarrito=false;
    }
  

    CargarPorDescripcionPg(){
        

      this.productoDTOService.getProductosDTOByDescripcionPg(this.currentPage, this.size, this.order, this.asc,0,this.formBuscar.value['txtBuscar']).subscribe(
        data => {
          this.content.push(...data.content);
         // this.isFirst = data.first;
         // this.isLast = data.last;
        //  this.totalPages = new Array(data['totalPages']);
        this.totalPages=data.totalPages;
          console.log(data);
        },
        err => {
          console.log(err.error);
        }
      );

    }


    onScroll(){
      if(this.modoBusqueda==false){
        //this.currentPage++;
       // this.cargarProductoPg();
      }else{
        this.currentPage++;
        this.CargarPorDescripcionPg();
      }

     
    }

 OnSelectProducto(idproducto:any){
    this.router.navigate(['/pedido', idproducto,0,0,0,0,0])
    .then(() => {
      window.location.reload();
    });

  
  }

}
